import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-neutral-300" }
const _hoisted_2 = { class: "bg-white color-black h-full p-4xl rounded-xl" }
const _hoisted_3 = { class: "text-4xl mb-lg font-weight-bold" }
const _hoisted_4 = { class: "mb-lg" }
const _hoisted_5 = { class: "bg-white color-black h-full p-4xl rounded-xl" }
const _hoisted_6 = { class: "text-4xl mb-lg font-weight-bold" }
const _hoisted_7 = { class: "mb-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Col = _resolveComponent("Col")!
  const _component_Row = _resolveComponent("Row")!
  const _component_Grid = _resolveComponent("Grid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Grid, {
      size: "lg",
      class: "py-5xl"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Row, { gap: "xl" }, {
          default: _withCtx(() => [
            _createVNode(_component_Col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.trans("general.are_you_a_press_officer")), 1),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.trans("general.get_access_and_more_information")), 1),
                  _createVNode(_component_Button, {
                    color: "accent",
                    to: { name: 'Register' }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.trans("general.sign_up")), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Col, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.trans("general.are_you_looking_for_company_material")), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.trans("general.get_more_images_and_information")), 1),
                  _createElementVNode("div", null, [
                    _createVNode(_component_Button, {
                      color: "accent",
                      to: { name: 'About' }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.trans("general.read_about_filmin")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}